import { combineReducers } from 'redux'
import { loadingArrayReducer } from '../../helpers/helpers'
import * as actions from './actions'

// The photo itself is not held in redux: it's served per subject by the photo endpoint and cached
// in Common/ProfilePhoto's module-level cache, which every mounted avatar subscribes to. The slice
// exists only so the mutations follow the standard action pattern and expose an in-flight flag.
export default combineReducers({
  loadingArray: loadingArrayReducer(
    [actions.prefix],
    [actions.UPDATE_PHOTO_REQUEST, actions.DELETE_PHOTO_REQUEST],
  ),
})
